import "../../CSS/HomeCSS/Competition.css";
import flag from "../../../assets/United Arab Emirates.png";
import Accordion from "react-bootstrap/Accordion";
import { useTranslation } from "react-i18next";
import {
  fetchLeaderBoard,
  STATUSES,
} from "../../../redux/getReducer/getLeader";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import Animate from "../../../assets/loader.json";
import Lottie from "lottie-react";
import noimage from "../../../assets/noimage1.png";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css'

const LeaderBoard = () => {
  const { t } = useTranslation();
  const { data: LeaderBoard, status } = useSelector(
    (state) => state.LeaderBoard
  );
  const dispatch = useDispatch();
  

  
  useEffect(() => {
    dispatch(fetchLeaderBoard());
  }, [dispatch]);

  const cookiedata = Cookies.get("i18next");
  if (status === STATUSES.LOADING) {
    return (
      <div>
        <Lottie
          animationData={Animate}
          loop={true}
          className="Lottie compLottie"
        />
      </div>
    );
  }

  if (status === STATUSES.ERROR) {
    return (
      <h2
        style={{
          margin: "100px",
        }}
      >
        Something went wrong!
      </h2>
    );
  }

  // function removeDuplicateIndexes(arr) {
  //   const uniqueMap = new Map();
  //   const result = [];
  
  //   for (const subArray of arr) {
  //     const uniqueSubArray = [];
  //     for (const item of subArray) {
  //       const key = item['SubscriberID'];
  //       if (!uniqueMap.has(key)) {
  //         uniqueMap.set(key, true);
  //         uniqueSubArray.push(item);
  //       }
  //     }
  //     result.push(uniqueSubArray);
  //     uniqueMap.clear();
  //   }
  //   return result;
  // }

  // const uniqueArray = removeDuplicateIndexes(LeaderBoard.map((item) => item.CompetitionIDData));

   const count = typeof window !== "undefined" && window.innerWidth < 520 ? 1 : 3;

  return (
    <React.Suspense>
      <div className="saddle-battle-leaderboard-wrapper w-100">
        <div className="my-new-leaderboard-container">
         
          <div className={`my-new-lb-main-header ${!LeaderBoard || LeaderBoard.length === 0 ? 'no-results-header' : ''}`}>
              <h2>{t("LEADERBOARD")}</h2>
          </div>

          <div className="my-new-leader-data-list">
              {status === STATUSES.LOADING ? (
                  <SkeletonTheme baseColor="#0d1b3e"  highlightColor="#1a2b5e">
                      <p className="my-new-skeleton-p">
                          <Skeleton count={count} height={50} style={{marginBottom: '10px', borderRadius: '20px'}} />
                      </p>
                  </SkeletonTheme>
              ) : !LeaderBoard || LeaderBoard.length === 0 ? (
                  <div className="my-new-no-results-card">
                      <div className="my-new-watermark-logo"></div>
                      <p>{t("No Results Available")}</p>
                  </div>
              ) : (
                  LeaderBoard.map((item, index) => {
                      // Logic preserved: checking for empty data
                      if (item.Points && item.Points.length === 0) return null;

                      return (
                          <Accordion key={index} defaultActiveKey="1" className="my-new-lb-accordion">
                              <div className="my-new-lb-item-wrapper">
                                  <Accordion.Item eventKey={index}>
                                      <Accordion.Header className="my-new-lb-header">
                                          <div className="my-new-lb-header-content">
                                              <p className="my-new-lb-comp-name">
                                                  {cookiedata === "en" ? item.Competition.NameEn : item.Competition.NameAr}
                                              </p>
                                          </div>
                                      </Accordion.Header>
                                      <Accordion.Body className="my-new-lb-body">
                                          {item.Points ? (
                                              item.Points.map((data, pIndex) => (
                                                  // Logic preserved: gained points > 0
                                                  data.PointGained > 0 ? (
                                                      <div className="my-new-lb-row" key={pIndex}>
                                                          <p className="my-new-lb-username">
                                                              {data ? data.FirstName : ""}
                                                          </p>
                                                          <p className="my-new-lb-points">
                                                              {data ? data.PointGained : ""}
                                                          </p>
                                                      </div>
                                                  ) : null
                                              ))
                                          ) : null}
                                      </Accordion.Body>
                                  </Accordion.Item>
                              </div>
                          </Accordion>
                      );
                  })
              )}
          </div>
        </div>
      </div>
     
    </React.Suspense>
  );
};
export default LeaderBoard;